/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { httpV2 } from "@/api/index";
import {
	GET_PARALLEL_MISALIGNMENT_HSS_RESULT,
	GET_PARALLEL_MISALIGNMENT_HSS_ERROR,
	GET_PARALLEL_MISALIGNMENT_HSS_SUCCESS,
	RESET_PARALLEL_MISALIGNMENT_HSS
} from "@/stores/actions/WindDiagnosticParallelMisalignmentHss";
import { DiagnosticRange } from "@/constants/enums/DiagnosticRange";

const state = {
	status: FetchStatus.Init,
	data:   { status: 0, },
	error:  {},
};

const actions = {
	[GET_PARALLEL_MISALIGNMENT_HSS_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_PARALLEL_MISALIGNMENT_HSS_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/ParallelMisalignmentHSS`)
			.then((resp) =>
			{
				commit(GET_PARALLEL_MISALIGNMENT_HSS_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_PARALLEL_MISALIGNMENT_HSS_ERROR, error.response);
			});
	},
	[RESET_PARALLEL_MISALIGNMENT_HSS]: ({ commit }) =>
	{
		commit(RESET_PARALLEL_MISALIGNMENT_HSS);
	},
};

const mutations = {
	[GET_PARALLEL_MISALIGNMENT_HSS_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_PARALLEL_MISALIGNMENT_HSS_SUCCESS]: (state, resp) =>
	{
		state.data = resp;

		state.status = FetchStatus.Loaded;
	},
	[GET_PARALLEL_MISALIGNMENT_HSS_ERROR]: (state, error) =>
	{
		state.error = error.response;
		state.status = FetchStatus.Error;
	},
	[RESET_PARALLEL_MISALIGNMENT_HSS]: (state) =>
	{
		state.data.status = DiagnosticRange.undefined;
		state.status = FetchStatus.Init;
	},
};

export default {
	state,
	actions,
	mutations,
};
